import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StepperBarStep } from '@shared/services/extras/_interfaces_/extras-steps.interface';

@Component({
  selector: 'stepper-bar',
  templateUrl: './stepper-bar.component.html',
  styleUrls: ['./stepper-bar.component.scss']
})
export class StepperBarComponent implements OnChanges {
  @Input() inputSteps: Array<StepperBarStep>;
  @Input() currentStep: number;
  stepNames: string[] = [];

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.inputSteps) {
      this.stepNames = this.mapSteps(this.inputSteps);
    }
  }

  mapSteps(input): string[] {
    let newSteps: string[] = [];
    input.map((e) => {
      newSteps.push(e.stepName);
    }); 
    return newSteps;
  }
}
